export function generateNewId(array) {

    if (array.length === 0) {
        return 1
    }

    var max = array.reduce(function (prev, current) {
        if (+current.id > +prev.id) {
            return current;
        } else {
            return prev;
        }
    });

    let newId = parseInt(max.id) + 1
    return newId;
}

export function getReadableBarcode(barcode) {
    const zeros_only = string => [...string].every(c => '0'.includes(c));
    if (barcode.length > 18) {
        if (zeros_only(barcode.substring(0, barcode.length - 18))) {
            barcode = barcode.slice(barcode.length - 18)
        }
    }

    return barcode
}

export function truncate(input, length) {
    return input.substring(0, length)
}

